<template>
  <div class="calico-container">
    <div
      v-for="section in sections"
      :key="section.title"
      class="container-display"
    >
      <h2 class="title">
        {{ section.title }}
      </h2>
      <div>
        <p>font-family:  <span class="font-info"> {{ section.fontFamily }}</span></p>
        <p>font-weight:  <span class="font-info"> {{ section.fontWeight }}</span></p>
        <p>line-height:  <span class="font-info"> {{ section.lineHeight }}</span></p>
      </div>
      <div
        v-for="text in section.texts"
        :key="text.class"
        class="text-container"
      >
        <p :class="text.class">
          {{ text.label }}
        </p>
        <p
          class="font-var"
          v-html="text.variables"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CalicoFont",
  data() {
    return {
      sections: [
        {
          title: "Display",
          fontFamily: "$font-heading",
          fontWeight: "$font-weight-regular",
          lineHeight: "$line-height-small",
          texts: [
            {
              class: "display--large",
              label: ".display--large",
              variables: "$font-size-display-large"
            },
            {
              class: "display--medium",
              label: ".display--medium",
              variables: "$font-size-display-medium"
            },
            {
              class: "display--small",
              label: ".display--small",
              variables: "$font-text<br>$font-size-header-large<br>$font-weight-regular"
            }
          ]
        },
        {
          title: "Heading",
          fontFamily: "$font-heading",
          fontWeight: "$font-weight-heavy",
          lineHeight: "$line-height-small",
          texts: [
            {
              class: "heading--large",
              label: ".heading--large",
              variables: "$font-size-header-large"
            },
            {
              class: "heading--medium",
              label: ".heading--medium",
              variables: "$font-size-header-medium"
            },
            {
              class: "heading--small",
              label: ".heading--small",
              variables: "$font-size-header-small"
            },
            {
              class: "heading--xsmall",
              label: ".heading--xsmall",
              variables: "$font-size-header-xsmall"
            }
          ]
        },
        {
          title: "Label",
          fontFamily: "$font-label",
          fontWeight: "$font-weight-regular",
          lineHeight: "$line-height-small",
          texts: [
            {
              class: "label--xsmall",
              label: ".label--xsmall",
              variables: "$font-size-xsmall"
            },
            {
              class: "label--small",
              label: ".label--small",
              variables: "$font-size-small"
            },
            {
              class: "label--medium",
              label: ".label--medium",
              variables: "$font-size-medium"
            },
            {
              class: "label--large",
              label: ".label--large",
              variables: "$font-size-large"
            }
          ]
        },
        {
          title: "Body",
          fontFamily: "$font-text",
          fontWeight: "$font-weight-regular",
          lineHeight: "$line-height-medium",
          texts: [
            {
              class: "body--xsmall",
              label: ".body--xsmall",
              variables: "$font-size-xsmall"
            },
            {
              class: "body--small",
              label: ".body--small",
              variables: "$font-size-small"
            },
            {
              class: "body--medium",
              label: ".body--medium",
              variables: "$font-size-medium"
            },
            {
              class: "body--large",
              label: ".body--large",
              variables: "$font-size-large"
            }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.calico-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 2rem 0;
  .container-display {
    @include stack-space($space-large);
    display: flex;
    flex-direction: column;
    width: 50%;
    height: auto;
    background-color: rgb(241, 241, 241);
    padding: 5rem;
    border-radius: 50px;
    p {
      padding: 0%;
      margin: 0%
    }
    .text-container {
      @include stack-space($space-medium);
    }
  }
}

.title {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 2rem;
  margin: auto;
}

.display--large,
.display--medium,
.display--small {
  font-weight: $font-weight-regular;
}


.font-info, .font-var {
  color: $color-orange;
  font-size: 14px;
}
</style>
